import api from "../api";

class OrderService {
    formatDate(date) {
        if (date == null || date === "") {
            return "";
        }
        return new Intl.DateTimeFormat("en-US", {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
        }).format(date);
    }

    GetFormattedDate(date) {
        if (date == null || date === "") {
            return "";
        }

        let month = date.getMonth() + 1,
            day = date.getDate(),
            year = date.getFullYear();

        return month + "/" + day + "/" + year;
    }

    async getAllOrders(filters) {
        return new Promise((res, reject) => {
            if (filters) {
                filters.startDate = this.GetFormattedDate(filters.startDate);
                filters.endDate = this.GetFormattedDate(filters.endDate);
            }

            api.get("/findOrdersByStatuses", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrdersWithLocations(filters) {
        return new Promise((res, reject) => {
            let params = {
                statuses: filters.statuses || [],
                reasonIds: filters.reasonIds || [],
                equipmentIds: filters.equipmentIds || [],
                internalLocations: filters.internalLocations || [],
                clinicLocations: filters.seatingClinics || [],
                salesOrService: filters.salesOrService || "Sales",
                startDate: this.GetFormattedDate(filters.startDate) || "",
                endDate: this.GetFormattedDate(filters.endDate) || "",
                DOB: this.GetFormattedDate(filters.dob) || "",
                q: filters.searchText || "",
                pageSize: filters.pageSize || 150,
            };
            api.get("/findOrdersWithLocations", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrderActivity(id) {
        return new Promise((res, rej) => {
            api.get("/order?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async getFlatOrderActivity(id) {
        return new Promise((res, rej) => {
            api.get("/orderFlat?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    getOrderProducts(id) {
        return new Promise((res, rej) => {
            if (id) {
                api
                    .get("/orders/getOrderProducts/" + id)
                    .then((data) => {
                        res(data);
                    })
                    .catch((err) => {
                        rej(err);
                    });
            } else {
                rej();
            }
        });
    }

    updateOrderProducts(id, prods) {
        return new Promise((res, rej) => {
            api
                .put("/orders/updateOrderProducts/" + id, prods)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    removeOrderProduct(id) {
        return new Promise((res, rej) => {
            api
                .post("/orders/removeOrderProduct/" + id) // id of the item to be removed
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    createPreAuth(id) {
        return new Promise((res, rej) => {
            api
                .post("/orders/createPreauth/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    getCurrentlyWorkingByOrder(id) {
        return new Promise((res, rej) => {
            api
                .get("/getCurrentlyWorkingOrder/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async syncToBrightTree(id) {
        return new Promise((res, rej) => {
            api.post("/syncToBrightTree/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    // calls proc spGetTechTimeline
    async getDeliveriesForLocation(locationId) {
        return new Promise((res, reject) => {
            api.get("/orders/deliveries/" + locationId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async updateDelivery(order) {
        return new Promise((res, reject) => {
            api.put("/orders/deliveriesUpdate", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getHomeAssessmentsFromWeb(orderId) {
        return new Promise((res, reject) => {
            api.post("/getHomeAssessment?orderId=" + orderId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getTechDeliveryTimeline(locationId, startDate, endDate) {
        return new Promise((res, reject) => {
            let params = {
                startDate: startDate,
                endDate: endDate,
            };
            api.get("/getTechTimeline/" + locationId, params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrdersWithLocationsNoDeliveryDate(filters) {
        return new Promise((res, reject) => {
            let params = {
                statuses: filters.statuses || "",
                internalLocations: filters.internalLocations || [],
                startDate: this.GetFormattedDate(filters.startDate) || "",
                endDate: this.GetFormattedDate(filters.endDate) || "",
                noScheduledDate: "true",
                q: filters.q,
                pageSize: filters.pageSize || 100,
            };
            api.get("/findOrdersWithLocationsNoScheduledDate", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrdersWithLocationsDeliveryDate(filters) {
        return new Promise((res, reject) => {
            let params = {
                statuses: filters.statuses || "",
                internalLocations: filters.internalLocations || [],
                startDate: filters.deliveryDateStart || "",
                endDate: filters.deliveryDateEnd || "",
                noScheduledDate: "true",
                users: filters.users || [],
                pageSize: filters.pageSize || 150,
            };
            api.get("/findDeliveries", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async searchOrders(filters) {
        return new Promise((res, reject) => {
            if (filters) {
                filters.startDate = this.GetFormattedDate(filters.startDate);
                filters.endDate = this.GetFormattedDate(filters.endDate);
            }

            api.get("/searchOrdersByStatuses", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetDashboardCounts
    async getDashboardCounts() {
        return new Promise((res, reject) => {
            api.get("/dashboard", null)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetOrderListing
    async getAllOrdersNative(filters) {
        return new Promise((res, reject) => {
            api.get("/orderListing", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetOrderById
    async getOrdersByIdNative(filters) {
        return new Promise((res, reject) => {
            api.get("/orderByIdNative", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spInsuranceVerificationView
    async getInsuranceVerificationViewNative(id) {
        return new Promise((res, reject) => {
            api.get("/verificationView?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc inProcessQueue
    async getInProcessView(regionId, reasonId) {
        return new Promise((res, reject) => {
            api.get("/inProcessView/" + reasonId + (regionId ? "?regionId=" + regionId : ""))
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spBillingView
    async getBillingViewNative(filters) {
        return new Promise((res, reject) => {
            api.get("/billingView", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetFollowupView
    async getFollowUpViewNative(id) {
        return new Promise((res, reject) => {
            api.get("/followupView?id=" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetATPView
    async getATPViewNative(filters) {
        return new Promise((res, reject) => {
            api.get("/atpView", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spCollectionsView
    async getCollectionsViewNative(filters) {
        return new Promise((res, reject) => {
            api.get("/collectionsView", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getActivity(id) {
        return new Promise((res, reject) => {
            api.get("/activities/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getApprovalsByOrder(orderId) {
        return new Promise((res, reject) => {
            api.get("/approvalByOrder/" + orderId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async updateApprovalByOrder(obj) {
        return new Promise((res, reject) => {
            api.put("/approval", obj)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async createOrder(order) {
        return new Promise((res, reject) => {
            api.post("/activities", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    //could be {data: order}
    async updateOrder(order) {
        return new Promise((res, reject) => {
            return api
                .put("/orders/update", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async updateFlatOrder(order) {
        return new Promise((res, reject) => {
            return api
                .put("/orders/updateFlat", order)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async updateOrderProperties(id, orderData) {
        return new Promise((res, reject) => {
            return api
                .post("/orders/updateOrderProperties/" + id, orderData)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async clearBeingWorkedBy(orderId) {
        return new Promise((res, rej) => {
            return api
                .post("/orders/clearBeingWorkedBy/" + orderId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async setBeingWorkedBy(orderId) {
        return new Promise((res, rej) => {
            return api.post("/orders/setBeingWorkedBy/" + orderId)
                .then(data => {
                    res(data);
                })
                .catch(err => {
                    rej(err);
                });
        });
    }

    async uploadDocument(order, file, fileName, userId, vendorId) {
        var sterilFilename = fileName.replaceAll(/[^.a-z0-9_-]/gi, '_').toLowerCase();
        return new Promise((res, reject) => {
            return api
                .downloadPost("/activities/" + order.id + "/files/" + sterilFilename + "/" + userId +
                    (vendorId ? "?vendorId=" + vendorId : ""),
                    file
                )
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async uploadDocumentWithStamp(order, file, fileName, userId, vendorId) {
        var sterilFilename = fileName.replaceAll(/[^.a-z0-9_-]/gi, '_').toLowerCase();
        return new Promise((res, reject) => {
            return api
                .downloadPost(
                    "/activities/" + order.id + "/fileswithstamp/" + sterilFilename + "/" + userId +
                    (vendorId ? "?vendorId=" + vendorId : ""),
                    file
                )
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async reprocessQuote(uploadedFileId) {
        let params = { UploadedFileId: uploadedFileId };
        return new Promise((res, reject) => {

            return api
                .post("/aiQuoteParser/sendToAiQuoteParser", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async uploadDocumentAdvanced(order, file, fileName, userId, sendToAiQuoteParser = false, vendorId = null) {
        const sterilFilename = fileName.replaceAll(/[^.a-z0-9_-]/gi, '_').toLowerCase();
        let query = `?sendToAiQuoteParser=${sendToAiQuoteParser}`;
        if (vendorId) {
            query += `&vendorId=${vendorId}`;
        }
        //No Product
        //     return({
        // "success": true,
        // "data": "{\"status\":\"success\",\"attributes\":{\"line_items\":[]},\"metrics\":{\"pdf.processing.input.scaling_factor\":2.0,\"orchestrator.document.text_extracted\":true,\"orchestrator.document.text_extracted_length\":68,\"orchestrator.document.page_count\":1,\"timing.orchestrator.pdf_processing.duration\":7.5218,\"vision.openai.deployment.used\":\"gpt-4.1\",\"timing.openai.chat.completion.duration\":2.8342,\"llm.usage.prompt_tokens\":2334,\"llm.usage.completion_tokens\":6,\"llm.usage.total_tokens\":2340,\"orchestrator.llm.response.model\":\"gpt-4.1\",\"orchestrator.llm.usage.prompt_tokens\":2334,\"orchestrator.llm.usage.completion_tokens\":6,\"orchestrator.llm.usage.total_tokens\":2340,\"timing.orchestrator.vision_analysis.duration\":2.8585,\"timing.pydantic.instantiation.Quote.duration\":0.0,\"timing.orchestrator.attribute_extraction.quote.duration\":0.0007,\"timing.total.processing.quote.duration\":10.4072},\"error_message\":null}"
        //     })


        //One product

//         return ({
//   "status": "success",
//   "attributes": {
//     "line_items": [
//       {
//         "part_number": "DRVASMB2298",
//         "description": "Left Motor Assembly",
//         "hcpcs": "E2370",
//         "qty": 1,
//         "msrp": 518.7,
//         "primary_discount": null,
//         "primary_discount_type": null,
//         "net_primary": null,
//         "secondary_discount": null,
//         "secondary_discount_type": null,
//         "price": 146.84,
//         "total": 146.84,
//         "autoSetProductSubType": true
//       }
//     ]
//   },
//   "metrics": {
//     "pdf.processing.input.scaling_factor": 2,
//     "orchestrator.document.text_extracted": true,
//     "orchestrator.document.text_extracted_length": 686,
//     "orchestrator.document.page_count": 1,
//     "timing.orchestrator.pdf_processing.duration": 4.2748,
//     "vision.openai.deployment.used": "gpt-4.1",
//     "timing.openai.chat.completion.duration": 2.8598,
//     "llm.usage.prompt_tokens": 2735,
//     "llm.usage.completion_tokens": 79,
//     "llm.usage.total_tokens": 2814,
//     "orchestrator.llm.response.model": "gpt-4.1",
//     "orchestrator.llm.usage.prompt_tokens": 2735,
//     "orchestrator.llm.usage.completion_tokens": 79,
//     "orchestrator.llm.usage.total_tokens": 2814,
//     "timing.orchestrator.vision_analysis.duration": 2.8708,
//     "timing.pydantic.instantiation.Quote.duration": 0,
//     "orchestrator.app.quote.items_found": true,
//     "timing.orchestrator.attribute_extraction.quote.duration": 0.0004,
//     "timing.total.processing.quote.duration": 7.1692
//   },
//   "error_message": null
        // })


        //Multiple products, some with no hcpcs
//         return({
//     "success": true,
//     "data": "{\"status\":\"success\",\"attributes\":{\"line_items\":[{\"part_number\":\"ELE2103635\",\"description\":\"MAGNETIC TO XLR CHARGER ADAPTER W/ WALL HOLDER, CURTIS (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":133.33,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":64.1,\"total\":64.1},{\"part_number\":\"ELE1704823\",\"description\":\"ELECTRONIC,ASSY,AFP W/MOUNTING BRACKET & HARDWARE,TB3,VERSION 2 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":84.07,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":26.63,\"total\":26.63},{\"part_number\":\"MEC2304102\",\"description\":\"FOOTPLATE ASSEMBLY, 5 X 11, 10-16 LENGTH, AFP STYLE 4, LEFT (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":1,\"msrp\":164.22,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":54.1,\"total\":54.1},{\"part_number\":\"MEC2304103\",\"description\":\"FOOTPLATE ASSEMBLY, 5 X 11, 10-16 LENGTH, AFP STYLE 4, RIGHT (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":1,\"msrp\":164.22,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":54.1,\"total\":54.1},{\"part_number\":\"DWR1404B003\",\"description\":\"FLAT NUT, LOWER ADJUSTMENT (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":2,\"msrp\":8.95,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":2.95,\"total\":5.9},{\"part_number\":\"HDW138262\",\"description\":\"WASHER, FLAT, 8.4 ID X 16 OD X 1.6 THK, ISO 7089-8-200 HV, BZ (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":4,\"msrp\":3.06,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":1.01,\"total\":4.04},{\"part_number\":\"RIG2005068\",\"description\":\"LEGREST,ASSY,SINGLE ACTUATOR,ARTICULATING FOOT PLATFORM,WMOUNTING HARDWARE,TRU-BALANCE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":2575.5,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":848.4,\"total\":848.4},{\"part_number\":\"RIGASMB7120018\",\"description\":\"SMALL CALF PADS, ADJ. CENTER MOUNT W/ HARDWARE, PAIR (S.NO:JE714025106020)\",\"hcpcs\":\"E0995\",\"qty\":1,\"msrp\":106.81,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":31.62,\"total\":31.62},{\"part_number\":\"ELE2001185\",\"description\":\"Q-LOGIC 3E JOYSTICK, 6MPH LINIX MOTORS W/ POWER POSITIONING, Q6EDGE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"E2374\",\"qty\":1,\"msrp\":1147.04,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":377.85,\"total\":377.85},{\"part_number\":\"DGN152585-PSL3\",\"description\":\"GREY STREET STANDARD FRONT BATTERY DOOR (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":152.76,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":48.38,\"total\":48.38},{\"part_number\":\"DGN1801101-PSL3\",\"description\":\"SHROUD,ASSY,GREY STREET,Q6 EDGE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":374.8,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":123.46,\"total\":123.46},{\"part_number\":\"DGN164245-PSL3\",\"description\":\"DRIVE WHEEL COLOR INSERT, WITH ADHESIVE TAPE, PPW-SIL-03 (GREY STREET) (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":2,\"msrp\":47.36,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":15.0,\"total\":30.0},{\"part_number\":\"DGN1714085-PSL3\",\"description\":\"ELECTRONICS BOX,ASSY,GREY STREET,W/MOUNTING HARDWARE (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":141.66,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":50.91,\"total\":50.91},{\"part_number\":\"HDW125250\",\"description\":\"SCREW, SOCKET HEAD, M8X1.25 X 20, ISO 4762, CL 12.9, BZ, PVTP (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":3.06,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":1.01,\"total\":1.01}]},\"metrics\":{\"pdf.processing.input.scaling_factor\":2.0,\"orchestrator.document.text_extracted\":true,\"orchestrator.document.text_extracted_length\":12374,\"orchestrator.document.page_count\":1,\"timing.orchestrator.pdf_processing.duration\":7.2629,\"vision.openai.deployment.used\":\"gpt-4.1\",\"timing.openai.chat.completion.duration\":14.7215,\"llm.usage.prompt_tokens\":5163,\"llm.usage.completion_tokens\":1062,\"llm.usage.total_tokens\":6225,\"orchestrator.llm.response.model\":\"gpt-4.1\",\"orchestrator.llm.usage.prompt_tokens\":5163,\"orchestrator.llm.usage.completion_tokens\":1062,\"orchestrator.llm.usage.total_tokens\":6225,\"timing.orchestrator.vision_analysis.duration\":14.7245,\"timing.pydantic.instantiation.Quote.duration\":0.0001,\"orchestrator.app.quote.items_found\":true,\"timing.orchestrator.attribute_extraction.quote.duration\":0.0006,\"timing.total.processing.quote.duration\":22.0107},\"error_message\":null}"
// })

        return new Promise((res, reject) => {
            return api
                .downloadPost(
                    `/activities/${order.id}/filesadvanced/${sterilFilename}/${userId}${query}`,
                    file
                )
                .then(res)
                .catch(reject);
        });
    }

    async uploadDocumentWithStampAdvanced(order, file, fileName, userId, sendToAiQuoteParser = false, vendorId = null) {
        const sterilFilename = fileName.replaceAll(/[^.a-z0-9_-]/gi, '_').toLowerCase();
        let query = `?sendToAiQuoteParser=${sendToAiQuoteParser}`;
        if (vendorId) {
            query += `&vendorId=${vendorId}`;
        }
        //No Product
        // return ({
        //     "success": true,

        //     "data": "{\"status\":\"success\",\"attributes\":{\"line_items\":[]},\"metrics\":{\"pdf.processing.input.scaling_factor\":2.0,\"orchestrator.document.text_extracted\":true,\"orchestrator.document.text_extracted_length\":68,\"orchestrator.document.page_count\":1,\"timing.orchestrator.pdf_processing.duration\":7.5218,\"vision.openai.deployment.used\":\"gpt-4.1\",\"timing.openai.chat.completion.duration\":2.8342,\"llm.usage.prompt_tokens\":2334,\"llm.usage.completion_tokens\":6,\"llm.usage.total_tokens\":2340,\"orchestrator.llm.response.model\":\"gpt-4.1\",\"orchestrator.llm.usage.prompt_tokens\":2334,\"orchestrator.llm.usage.completion_tokens\":6,\"orchestrator.llm.usage.total_tokens\":2340,\"timing.orchestrator.vision_analysis.duration\":2.8585,\"timing.pydantic.instantiation.Quote.duration\":0.0,\"timing.orchestrator.attribute_extraction.quote.duration\":0.0007,\"timing.total.processing.quote.duration\":10.4072},\"error_message\":null}"
        // })

        //One product
        // return ({
        // "success": true,
        // "data": "{\"status\":\"success\",\"attributes\":{\"line_items\":[{\"part_number\":\"DRVASMB2298\",\"description\":\"Left Motor Assembly\",\"hcpcs\":\"E2370\",\"qty\":1,\"msrp\":518.7,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":146.84,\"total\":146.84,\"autoSetProductSubType\":true}]},\"metrics\":{\"pdf.processing.input.scaling_factor\":2,\"orchestrator.document.text_extracted\":true,\"orchestrator.document.text_extracted_length\":686,\"orchestrator.document.page_count\":1,\"timing.orchestrator.pdf_processing.duration\":4.2748,\"vision.openai.deployment.used\":\"gpt-4.1\",\"timing.openai.chat.completion.duration\":2.8598,\"llm.usage.prompt_tokens\":2735,\"llm.usage.completion_tokens\":79,\"llm.usage.total_tokens\":2814,\"orchestrator.llm.response.model\":\"gpt-4.1\",\"orchestrator.llm.usage.prompt_tokens\":2735,\"orchestrator.llm.usage.completion_tokens\":79,\"orchestrator.llm.usage.total_tokens\":2814,\"timing.orchestrator.vision_analysis.duration\":2.8708,\"timing.pydantic.instantiation.Quote.duration\":0,\"orchestrator.app.quote.items_found\":true,\"timing.orchestrator.attribute_extraction.quote.duration\":0.0004,\"timing.total.processing.quote.duration\":7.1692},\"error_message\":null}"
        // });

        //Multiple products, some with no hcpcs
        // return ({
        //     "success": true,
        //     "data": "{\"status\":\"success\",\"attributes\":{\"line_items\":[{\"part_number\":\"ELE2103635\",\"description\":\"MAGNETIC TO XLR CHARGER ADAPTER W/ WALL HOLDER, CURTIS (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":133.33,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":64.1,\"total\":64.1},{\"part_number\":\"ELE1704823\",\"description\":\"ELECTRONIC,ASSY,AFP W/MOUNTING BRACKET & HARDWARE,TB3,VERSION 2 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":84.07,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":26.63,\"total\":26.63},{\"part_number\":\"MEC2304102\",\"description\":\"FOOTPLATE ASSEMBLY, 5 X 11, 10-16 LENGTH, AFP STYLE 4, LEFT (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":1,\"msrp\":164.22,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":54.1,\"total\":54.1},{\"part_number\":\"MEC2304103\",\"description\":\"FOOTPLATE ASSEMBLY, 5 X 11, 10-16 LENGTH, AFP STYLE 4, RIGHT (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":1,\"msrp\":164.22,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":54.1,\"total\":54.1},{\"part_number\":\"DWR1404B003\",\"description\":\"FLAT NUT, LOWER ADJUSTMENT (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":2,\"msrp\":8.95,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":2.95,\"total\":5.9},{\"part_number\":\"HDW138262\",\"description\":\"WASHER, FLAT, 8.4 ID X 16 OD X 1.6 THK, ISO 7089-8-200 HV, BZ (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":4,\"msrp\":3.06,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":1.01,\"total\":4.04},{\"part_number\":\"RIG2005068\",\"description\":\"LEGREST,ASSY,SINGLE ACTUATOR,ARTICULATING FOOT PLATFORM,WMOUNTING HARDWARE,TRU-BALANCE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":2575.5,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":848.4,\"total\":848.4},{\"part_number\":\"RIGASMB7120018\",\"description\":\"SMALL CALF PADS, ADJ. CENTER MOUNT W/ HARDWARE, PAIR (S.NO:JE714025106020)\",\"hcpcs\":\"E0995\",\"qty\":1,\"msrp\":106.81,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":31.62,\"total\":31.62},{\"part_number\":\"ELE2001185\",\"description\":\"Q-LOGIC 3E JOYSTICK, 6MPH LINIX MOTORS W/ POWER POSITIONING, Q6EDGE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"E2374\",\"qty\":1,\"msrp\":1147.04,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":377.85,\"total\":377.85},{\"part_number\":\"DGN152585-PSL3\",\"description\":\"GREY STREET STANDARD FRONT BATTERY DOOR (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":152.76,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":48.38,\"total\":48.38},{\"part_number\":\"DGN1801101-PSL3\",\"description\":\"SHROUD,ASSY,GREY STREET,Q6 EDGE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":374.8,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":123.46,\"total\":123.46},{\"part_number\":\"DGN164245-PSL3\",\"description\":\"DRIVE WHEEL COLOR INSERT, WITH ADHESIVE TAPE, PPW-SIL-03 (GREY STREET) (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":2,\"msrp\":47.36,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":15.0,\"total\":30.0},{\"part_number\":\"DGN1714085-PSL3\",\"description\":\"ELECTRONICS BOX,ASSY,GREY STREET,W/MOUNTING HARDWARE (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":141.66,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":50.91,\"total\":50.91},{\"part_number\":\"HDW125250\",\"description\":\"SCREW, SOCKET HEAD, M8X1.25 X 20, ISO 4762, CL 12.9, BZ, PVTP (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":3.06,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":1.01,\"total\":1.01}]},\"metrics\":{\"pdf.processing.input.scaling_factor\":2.0,\"orchestrator.document.text_extracted\":true,\"orchestrator.document.text_extracted_length\":12374,\"orchestrator.document.page_count\":1,\"timing.orchestrator.pdf_processing.duration\":7.2629,\"vision.openai.deployment.used\":\"gpt-4.1\",\"timing.openai.chat.completion.duration\":14.7215,\"llm.usage.prompt_tokens\":5163,\"llm.usage.completion_tokens\":1062,\"llm.usage.total_tokens\":6225,\"orchestrator.llm.response.model\":\"gpt-4.1\",\"orchestrator.llm.usage.prompt_tokens\":5163,\"orchestrator.llm.usage.completion_tokens\":1062,\"orchestrator.llm.usage.total_tokens\":6225,\"timing.orchestrator.vision_analysis.duration\":14.7245,\"timing.pydantic.instantiation.Quote.duration\":0.0001,\"orchestrator.app.quote.items_found\":true,\"timing.orchestrator.attribute_extraction.quote.duration\":0.0006,\"timing.total.processing.quote.duration\":22.0107},\"error_message\":null}"
        // })

             //Multiple products, some with no hcpcs or price
        // return ({
        //     "success": true,
        //     "data": "{\"status\":\"success\",\"attributes\":{\"line_items\":[{\"part_number\":\"ELE2103635\",\"description\":\"MAGNETIC TO XLR CHARGER ADAPTER W/ WALL HOLDER, CURTIS (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":133.33,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":64.1,\"total\":64.1},{\"part_number\":\"ELE1704823\",\"description\":\"ELECTRONIC,ASSY,AFP W/MOUNTING BRACKET & HARDWARE,TB3,VERSION 2 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":84.07,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":26.63,\"total\":26.63},{\"part_number\":\"MEC2304102\",\"description\":\"FOOTPLATE ASSEMBLY, 5 X 11, 10-16 LENGTH, AFP STYLE 4, LEFT NO HCPC NO PRICE (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":1,\"msrp\":null,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":null,\"total\":54.1},{\"part_number\":\"MEC2304103\",\"description\":\"FOOTPLATE ASSEMBLY, 5 X 11, 10-16 LENGTH, AFP STYLE 4, RIGHT (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":1,\"msrp\":164.22,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":54.1,\"total\":54.1},{\"part_number\":\"DWR1404B003\",\"description\":\"FLAT NUT, LOWER ADJUSTMENT (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":2,\"msrp\":8.95,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":2.95,\"total\":5.9},{\"part_number\":\"HDW138262\",\"description\":\"WASHER, FLAT, 8.4 ID X 16 OD X 1.6 THK, ISO 7089-8-200 HV, BZ (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":4,\"msrp\":3.06,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":1.01,\"total\":4.04},{\"part_number\":\"RIG2005068\",\"description\":\"LEGREST,ASSY,SINGLE ACTUATOR,ARTICULATING FOOT PLATFORM,WMOUNTING HARDWARE,TRU-BALANCE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":2575.5,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":848.4,\"total\":848.4},{\"part_number\":\"RIGASMB7120018\",\"description\":\"SMALL CALF PADS, ADJ. CENTER MOUNT W/ HARDWARE, PAIR (S.NO:JE714025106020)\",\"hcpcs\":\"E0995\",\"qty\":1,\"msrp\":106.81,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":31.62,\"total\":31.62},{\"part_number\":\"ELE2001185\",\"description\":\"Q-LOGIC 3E JOYSTICK, 6MPH LINIX MOTORS W/ POWER POSITIONING, Q6EDGE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"E2374\",\"qty\":1,\"msrp\":1147.04,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":377.85,\"total\":377.85},{\"part_number\":\"DGN152585-PSL3\",\"description\":\"GREY STREET STANDARD FRONT BATTERY DOOR (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":152.76,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":48.38,\"total\":48.38},{\"part_number\":\"DGN1801101-PSL3\",\"description\":\"SHROUD,ASSY,GREY STREET,Q6 EDGE 3 (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":374.8,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":123.46,\"total\":123.46},{\"part_number\":\"DGN164245-PSL3\",\"description\":\"DRIVE WHEEL COLOR INSERT, WITH ADHESIVE TAPE, PPW-SIL-03 (GREY STREET) (S.NO:JE714025106020)\",\"hcpcs\":null,\"qty\":2,\"msrp\":47.36,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":15.0,\"total\":30.0},{\"part_number\":\"DGN1714085-PSL3\",\"description\":\"ELECTRONICS BOX,ASSY,GREY STREET,W/MOUNTING HARDWARE (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":141.66,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":50.91,\"total\":50.91},{\"part_number\":\"HDW125250\",\"description\":\"SCREW, SOCKET HEAD, M8X1.25 X 20, ISO 4762, CL 12.9, BZ, PVTP (S.NO:JE714025106020)\",\"hcpcs\":\"K0108\",\"qty\":1,\"msrp\":3.06,\"primary_discount\":null,\"primary_discount_type\":null,\"net_primary\":null,\"secondary_discount\":null,\"secondary_discount_type\":null,\"price\":1.01,\"total\":1.01}]},\"metrics\":{\"pdf.processing.input.scaling_factor\":2.0,\"orchestrator.document.text_extracted\":true,\"orchestrator.document.text_extracted_length\":12374,\"orchestrator.document.page_count\":1,\"timing.orchestrator.pdf_processing.duration\":7.2629,\"vision.openai.deployment.used\":\"gpt-4.1\",\"timing.openai.chat.completion.duration\":14.7215,\"llm.usage.prompt_tokens\":5163,\"llm.usage.completion_tokens\":1062,\"llm.usage.total_tokens\":6225,\"orchestrator.llm.response.model\":\"gpt-4.1\",\"orchestrator.llm.usage.prompt_tokens\":5163,\"orchestrator.llm.usage.completion_tokens\":1062,\"orchestrator.llm.usage.total_tokens\":6225,\"timing.orchestrator.vision_analysis.duration\":14.7245,\"timing.pydantic.instantiation.Quote.duration\":0.0001,\"orchestrator.app.quote.items_found\":true,\"timing.orchestrator.attribute_extraction.quote.duration\":0.0006,\"timing.total.processing.quote.duration\":22.0107},\"error_message\":null}"
        // })

        return new Promise((res, reject) => {
            return api
                .downloadPost(
                    `/activities/${order.id}/fileswithstampadvanced/${sterilFilename}/${userId}${query}`,
                    file
                )
                .then(res)
                .catch(reject);
        });
    }


    async getDocumentThumbnails(docId) {
        return new Promise((res, reject) => {
            return api
                .get("/deliveryPaperwork/image/" + docId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async downloadDocument(orderId, fileName, userId, file) {
        return new Promise((res, reject) => {
            return api.downloadPost("/api/activities/" + orderId + "/files/" + fileName + "/" + userId, file)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async downloadDoc(id) {
        return new Promise((res, reject) => {
            return api
                .getFile("/files/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async deleteDocument(id) {
        return new Promise((res, reject) => {
            return api
                .delete("/files/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrderTimeline(order) {
        return new Promise((res, reject) => {
            return api
                .get("/orders/orderHistory/" + order.id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrdersByAccount(id) {
        return new Promise((res, reject) => {
            let params = {
                    page: 0,
                    size: 25,
                },
                url = "/accounts/" + id + "/orders";

            return api
                .get(url, params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrderAttachments(id) {
        return new Promise((res, reject) => {
            return api
                .get("/activity/files/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getPatients() {
        return new Promise((res, reject) => {
            return api
                .get("/patients")
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getPatientById(patientId) {
        return new Promise((res, reject) => {
            return api
                .get("/patient?id=" + patientId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


    async getPatientChartById(patientId) {
        let params = { PatientId: parseInt(patientId) };
        return new Promise((res, reject) => {
            return api
                .post("/chart/get", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getPatientEquipment(patientId) {
        return new Promise((res, reject) => {
            return api
                .get("/patientEquipmentTickets/" + patientId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getPatientOrdersById(patientId) {
        return new Promise((res, reject) => {
            return api
                .get("/patientOrders/" + patientId)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetPatientList
    async getPatientsByInformation(fName, lName, dob, phone, brightreeExternalIds, brightreeExternalKeys, hasCollectionsBalance, recordReturnLimit) {
        let patientSearchRequest = {
            firstName: fName || null,
            lastName: lName || null,
            birthDate: dob || null,
            phone: phone || null,
            brightreeExternalIds: brightreeExternalIds?.length ? brightreeExternalIds : null,
            brightreeExternalKeys: brightreeExternalKeys?.length ? brightreeExternalKeys : null,
            hasCollectionsBalance: hasCollectionsBalance || null,
            recordReturnLimit: recordReturnLimit || null
        };

        return new Promise((res, reject) => {
            return api
                .post("/patients", patientSearchRequest)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async updatePatient(data, updateOrders) {
        let params = "";
        if (updateOrders) {
            params = "?updateOrders=true";
        }
        return new Promise((res, reject) => {
            return api
                .put("/patient" + params, data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async createPatient(data) {
        return new Promise((res, reject) => {
            return api
                .post("/patient", data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spMergePatients
    async mergePatients(params) {
        return new Promise((res, reject) => {
            return api
                .get("/mergePatients", params)
                .then(() => {
                    res();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async mergeDocuments(order, fileIds) {
        return new Promise((res, reject) => {
            return api
                .post("/activities/" + order.id + "/merge", fileIds)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async mergePagedDocuments(order, files, name, userId) {
        return new Promise((res, reject) => {
            return api
                .post("/activities/" + order.id + "/mergepages/" + name + "/" + userId, files)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // calls proc spGetDeliveryAverages
    async getDashboardDeliveryAverages(props) {
        let params = null;

        if (props != null) {
            params = { id: props };
        }

        return new Promise((res, reject) => {
            api.get("/deliveryAverages", params)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getAllOrderFrequency() {
        return new Promise((res, reject) => {
            api.get("/recurringOrders")
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrderFrequency(id) {
        return new Promise((res, reject) => {
            api.get("/orders/recurringOrders/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async createOrderFrequency(data) {
        return new Promise((res, reject) => {
            return api
                .post("/orders/recurringOrders", data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async updateOrderFrequency(data) {
        return new Promise((res, reject) => {
            return api
                .put("/orders/recurringOrders", data)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getOrderListing(filters) {
        return new Promise((res, reject) => {
            return api
                .get("/orderListing", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async syncOrderWithBT(id) {
        if (window.salesPilot.meta.environment === "development") {
            return new Promise((res, reject) => {
                setTimeout(() => {
                    // Mock condition: If id is odd, resolve; if even, reject
                    if (id % 2 === 1) {
                        res({ success: true, message: `Order ${id} synced successfully.` });
                    } else {
                        reject({ success: false, message: `Order ${id} failed to sync.` });
                    }
                }, 3000);
            });
        } else {
            return new Promise((res, reject) => {
                return api
                    .post("/orders/syncToBt/" + id)
                    .then((data) => {
                        res(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    }

    async getServiceOrderReason(id) {
        return new Promise((res, rej) => {
            return api
                .get("/orders/serviceOrderReasonByCurrent/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async buildPaSummary(items) {
        return new Promise((res, reject) => {
            return api
                .post("/buildPaSummary", items)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async getPatientLastChartNotes(id) {
        return new Promise((res, rej) => {
            return api
                .get("/patientChartNoteMeta/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async getPipelineView(id) {
        return new Promise((res, rej) => {
            return api
                .get("/pipelineView" + (id ? "?regionId=" + id : ""))
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }

    async getPaymentsCollected(filters) {
        return new Promise((res, reject) => {
            api
                .get("/getPaymentsCollected", filters)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

}

const orderService = new OrderService();

export default orderService;
